module.exports = __webpack_public_path__ + "img/hospLogo.b38793c1.png";